// src/pages/products/SparkPlugsPage.tsx
import React from 'react';
import { Button, Modal, Input, Tag } from 'antd';
import { SparkPlugItem } from '../../types/ProductItems';
import SparkPlugForm from '../../components/forms/SparkPlugForm';
import SparkPlugsTable from '../../components/tables/SparkPlugsTable';
import { useProductManager } from '../../hooks/useProductManager';
import { STORE_NAMES } from '../../utils/db';

const SparkPlugsPage: React.FC = () => {
  const [search, setSearch] = React.useState('');

  const {
    items: sparkPlugs,
    currentItem,
    setCurrentItem,
    isModalVisible,
    setIsModalVisible,
    addItem: handleAddSparkPlugs,
    deleteItem: handleDelete,
    exportToExcel,
  } = useProductManager<SparkPlugItem>(STORE_NAMES.sparkPlugs);

  const handleEdit = (item: SparkPlugItem) => {
    setCurrentItem(item);
    setIsModalVisible(true);
  };

  const filtered = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return sparkPlugs;
    return sparkPlugs.filter(item =>
      [item.brand, item.partNumber, item.model, item.original, String(item.price)]
        .filter(Boolean)
        .some(v => String(v).toLowerCase().includes(q))
    );
  }, [sparkPlugs, search]);

  const totalCount = sparkPlugs.length;
  const shownCount = filtered.length;

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>

        <Button type="primary" onClick={() => { setIsModalVisible(true); setCurrentItem(null); }}>
          Добавить свечу зажигания
        </Button>

        <Button onClick={() => exportToExcel('SparkPlugs_Export')}>
          📁 Экспорт в Excel
        </Button>

        <Input
          placeholder="Поиск…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: 280 }}
          allowClear
        />

        <Tag className="small-tag">Всего: {totalCount}</Tag>
        <Tag color="blue" className="small-tag">Показано: {shownCount}</Tag>

      </div>

      <SparkPlugsTable data={filtered} onEdit={handleEdit} onDelete={handleDelete} />

      <Modal
        title={currentItem ? 'Редактировать свечу зажигания' : 'Добавить свечу зажигания'}
        open={isModalVisible}
        onCancel={() => { setIsModalVisible(false); setCurrentItem(null); }}
        footer={null}
        destroyOnHidden
      >
        <SparkPlugForm onAdd={handleAddSparkPlugs} initialValues={currentItem} />
      </Modal>
    </div>
  );
};

export default SparkPlugsPage;
